export default {
  actionToExecute: 'Action to execute',
  addAction: 'Add action',
  addListToSequence: 'Add list to sequence',
  addPerson: 'Add person',
  addPersonOrStep: 'Add person or step',
  addScheduleName: 'Add schedule name',
  addScheduleObservations: 'Add schedule observations',
  addStep: 'Add step',
  addTask: 'Add task',
  addTrigger: 'Add trigger',
  addUserToSequence: 'Add user to sequence',
  automaticEmail: 'Automatic email',
  changeUserFromSequence: 'Change user from sequence',
  companyName: 'Company name',
  completion: 'Completion',
  continueWithoutSaving: 'Continue without saving',
  copyCustomizedField: 'Copy customized field',
  couldNotCopyFieldToClipboard: 'Could not copy field to clipboard',
  createAValidTask: 'Create a valid task',
  createRule: 'Create rule',
  createSequence: 'Create sequence',
  customFieldSuccessfullyCopiedToClipboard: 'Custom field successfully copied to clipboard',
  customizeDay: 'Customize day',
  customizeScheduleDays: 'Customize schedule days',
  dayDisabled: 'Day disabled',
  days: 'Days',
  deleteAction: 'Delete action',
  deleteList: 'Delete list',
  deleteSequence: 'Delete sequence',
  deleteTrigger: 'Delete trigger',
  deleteUserFromSequence: 'Delete user from sequence',
  deleteUserFromSequenceConfirmation: 'Do you really want to delete this user from the sequence',
  doNothing: 'Do nothing',
  doYouReallyWanToDeleteThisSequence: 'Do you really want to delete this sequence?',
  editList: 'Edit list',
  editPerson: 'Edit person',
  editRule: 'Edit rule',
  editSchedule: 'Edit schedule',
  emailHooksInformation: 'Email\'s hooks information',
  emailStatistics: 'Email statistics',
  enterRuleDescription: 'Enter rule description',
  editSequence: 'Edit sequence',
  editStep: 'Edit step',
  enterRuleName: 'Enter rule name',
  enterStepName: 'Enter step name',
  enterStepOrder: 'Enter step order',
  enterStepTips: 'Enter step tips',
  enterTaskName: 'Enter task name',
  enterTriggerName: 'Enter trigger name',
  executeAnotherActionInAGivenTime: 'Execute another action in a given time',
  exitWhen: 'Exit when',
  goBackToTheSequence: 'Go back to the sequence',
  hours: 'Hours',
  ifNotSequenceStepPickedNote: 'Note: If you don\'t pick a step, the next sequence step is going to be picked by default',
  insertEmailSubject: 'Insert email subject',
  isActive: 'Is active',
  isDayActive: 'Is day active',
  isGlobal: 'Is global',
  isSequenceActive: 'Is sequence active',
  isStepActive: 'Is step active',
  lastEditionDate: 'Last edition date',
  listNotFound: 'List not found',
  listSuccessfullyAddedToSequence: 'List successfully added to sequence',
  listView: 'List view',
  loadingInformation: 'Loading information',
  loadingRule: 'Loading rule',
  loadingSchedule: 'Loading schedule',
  loadingSequence: 'Loading sequence',
  loadingSequenceStatistics: 'Loading sequence statistics',
  loadingStep: 'Loading step',
  manualEmail: 'Manual email',
  nestedActionToExecute: 'Nested action to execute',
  newRule: 'New rule',
  newSchedule: 'New schedule',
  newSequence: 'New sequence',
  noRulesCreated: 'No rules created',
  noSchedulesCreated: 'No schedules created',
  noSequencesCreated: 'No sequences created',
  order: 'Order',
  owner: 'Owner',
  pauseSequence: 'Pause sequence',
  peopleInTheSequence: 'People in the sequence',
  peoplePerStep: 'People per step',
  peopleThatLeftTheSequence: 'People that left the sequence',
  personSuccessfullyAddedToSequence: 'Person successfully added to sequence',
  personSuccessfullyChangedFromSequence: 'Person successfully changed from sequence',
  personSuccessfullyCreated: 'Person successfully created',
  personSuccessfullyUpdated: 'Person successfully updated',
  pickAnAction: 'Pick an action',
  pickAnHour: 'Pick an hour',
  pickADate: 'Pick a date',
  pickARule: 'Pick a rule',
  pickASchedule: 'Pick a schedule',
  pickAScheduleForTheSequence: 'Pick a schedule for the sequence',
  pickAStep: 'Pick a step',
  pickFinishingTime: 'Pick finishing time',
  pickHour: 'Pick hour',
  pickMinutes: 'Pick minutes',
  pickTimeZone: 'Pick time zone',
  pickStartingDateTimeAndTimeZone: 'Pick the starting date, time and time zone',
  pickStartingTime: 'Pick starting time',
  pickTheSequenceToChangeTo: 'Pick the sequence to change to',
  pickTheStepToChangeTo: 'Pick the step to change to',
  pickTriggerType: 'Pick trigger type',
  prepareEmail: 'Prepare email',
  project: 'Project',
  relateRuleToSequence: 'Relate rule to a sequence',
  relateRuleToSequenceOrSetAsGlobal: 'Relate rule to a sequence or set as global',
  removeUserFromSequence: 'Remove user from sequence',
  ruleDetails: 'Rule details',
  ruleNotFound: 'Rule not found',
  ruleSuccessfullyCreated: 'Rule successfully created',
  ruleSuccessfullyUpdated: 'Rule successfully updated',
  rules: 'Rules',
  runSequence: 'Run sequence',
  saveTemplate: 'Save template',
  saveTemplateWarning: 'You haven\'t saved or updated this template, are you sure to continue without saving or updating it?',
  scheduleDays: 'Schedule days',
  scheduleName: 'Schedule name',
  scheduleObservations: 'Schedule observations',
  scheduleSuccessfullyCreated: 'Schedule successfully created',
  scheduleSuccessfullyUpdated: 'Schedule successfully updated',
  schedules: 'Schedules',
  seeList: 'See list',
  seePerson: 'See person',
  seeSequence: 'See sequence',
  selectARule: 'Select a rule',
  selectASequence: 'Select a sequence',
  sequence: 'Sequence',
  sequenceCompany: 'Sequence company',
  sequenceDetails: 'Sequence details',
  sequenceInformationWillBeLostAfterDeletionOfTheSequence: 'All the leads, steps and any information related to the sequence will be no longer available',
  sequenceLeads: 'Sequence leads',
  sequenceName: 'Sequence name',
  sequenceOwner: 'Sequence owner',
  sequencePeople: 'Sequence people',
  sequenceRuleType: 'Rule type',
  sequenceSchedule: 'Sequence schedule',
  sequenceStatistics: 'Sequence statistics',
  sequenceStatisticsNotFound: 'Sequence statistics not found',
  sequenceStatus: 'Sequence status',
  sequenceStatusSuccessfullyChanged: 'Sequence status successfully changed',
  sequenceSteps: 'Sequence steps',
  sequenceSuccessfullyCreated: 'Sequence successfully created',
  sequenceSuccessfullyDeleted: 'Sequence successfully deleted',
  sequenceSuccessfullyUpdated: 'Sequence successfully updated',
  sequences: 'Sequences',
  sequencesRules: 'Sequences rules',
  sequencesList: 'Sequences list',
  setRuleAsGlobal: 'Set rule as global',
  sms: 'Sms',
  smsHooksInformation: 'Sms\'s hooks information',
  smsStatistics: 'Sms statistics',
  social: 'Social',
  settings: 'Settings',
  statistics: 'Statistics',
  step: 'Step',
  stepSuccessfullyCreated: 'Step successfully created',
  stepSuccessfullyUpdated: 'Step successfully updated',
  stepTips: 'Step tips',
  stepType: 'Step type',
  task: 'Task',
  taskHooksInformation: 'Task\'s hooks information',
  taskStatistics: 'Task statistics',
  templateSuccessfullySaved: 'Template successfully saved',
  templateSuccessfullyUpdated: 'Template successfully updated',
  theSequenceIsRunningNow: 'The sequence is running now',
  timeToFinishTheTaskAfterRuleGetsExecuted: 'Time to finish the task after the rule get\'s executed',
  timeToWaitBeforeRunningThisStep: 'Time to wait before running this step',
  timeToWaitBeforeNestedActionGetsExecuted: 'Time to wait before nested action gets executed',
  tipsForTheStep: 'Tips for the {type}',
  triggerName: 'Trigger name',
  triggerActions: 'Trigger actions',
  updateTemplateWarning: 'Template {templateName} is going to be updated, are you sure of this?',
  userNotFound: 'User not found',
  userSuccessfullyDeletedFromSequence: 'User successfully deleted from sequence',
  waitFor: 'Wait for',
  withoutTips: 'Without tips',
  writeEmail: 'Write email',
  writeSms: 'Write SMS',
  youMustFillAllFieldsCorrectly: 'You must fill all fields correctly',
  youMustPickADate: 'You must pick a date',
  pickAnOutcome: 'Pick an outcome',
  pickAnOutcomeForTheTask: 'Pick an outcome for the task',
  deliveredPlural: 'Delivered | Delivered',
  clickedPlural: 'Clicked | Clicked',
  deferral: 'Deferral | Deferral',
  hardBounced: 'Hard bounced | Hard bounced',
  softBounced: 'Soft bounced | Soft bounced',
  spamBlocked: 'Spam blocked | Spam blocked',
  unsubscribed: 'Unsubscribed | Unsubscribed',
  blackList: 'Black list',
  whiteList: 'White list',
  unknown: 'Unknown | Unknown',
  pending: 'Pending | Pending',
  scheduled: 'Scheduled | Scheduled',
  queued: 'Queued | Queued'
}
